// @ts-nocheck
import { ACCOUNTING_REPORT_RECEIVED } from '../types';

const initialState = {
    list: [],
};

const accountingReport = (state = initialState, action) => {
    const { payload } = action;
    switch (action.type) {
        case ACCOUNTING_REPORT_RECEIVED: {
            return {
                ...state,
                list: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default accountingReport;
